import { BiSave } from "react-icons/bi"; 
import CxIconButtonNew from '../../cx/CxIconButtonNew';
import CxIcon from '../../cx/CxIcon';
import React from 'react';
import { useTranslation } from '../../hx/useTranslation';
import CxCombo from '../../cx/CxCombo';
import CxNumber from '../../cx/CxNumber';
import CxAccordion from '../../cx/CxAccordion';
import CxSnackbar from '../../cx/CxSnackbar';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import '../../../styles/main.css';
import GxForm from '../../gx/GxForm';


const MxPrefsLocalsForm = (props) => {
  const [{ trans }] = useTranslation();

  let r_form = React.useRef(null);

  const rf_startupMod = React.useRef(null);
  const rf_inet_outage_notice = React.useRef(null);
  const rf_sales_slip_width = React.useRef(null);
  const rf_sales_slip_margin_left = React.useRef(null);

  const r_snack_save = React.useRef(null);

  React.useEffect(() => {
    formLoad();
    // eslint-disable-next-line
  }, []);

  const formLoad = async () => {
    rf_startupMod.current.setVal(localStorage.getItem('MxLogin.startup_mod') || 'client-list');
    rf_inet_outage_notice.current.setVal(localStorage.getItem('MxMain.inet_outage_notice') || 'Y');

    let txSalesSlipWidth = localStorage.getItem('MxSettSlsPrinting.sales_slip_width');
    let txSalesSlipMarginLeft = localStorage.getItem('MxSettSlsPrinting.sales_slip_margin_left');
    rf_sales_slip_width.current.setVal(txSalesSlipWidth||'60');
    rf_sales_slip_margin_left.current.setVal(txSalesSlipMarginLeft);
  }

  const formSaveCustom = async () => {
    localStorage.setItem('MxLogin.startup_mod', rf_startupMod.current.getVal());
    localStorage.setItem('MxMain.inet_outage_notice', rf_inet_outage_notice.current.getVal());
    localStorage.setItem('MxSettSlsPrinting.sales_slip_width', rf_sales_slip_width.current.getVal());
    localStorage.setItem('MxSettSlsPrinting.sales_slip_margin_left', rf_sales_slip_margin_left.current.getVal());
    r_snack_save.current.setOpen(true);
  }

  return (
    <div>
      <GxForm
        moduleName={`${trans('field.prefs')}-${trans('field.locals')}`}
        xref={r_form}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <CxIconButtonNew icon={<CxIcon backIcon={<BiSave/>} />} classType="ibs_iconbutton_toolbar" onClick={() => formSaveCustom()} tooltip={trans('field.save')} />
          </div>
        }
      >
        <CxCombo xref={rf_startupMod}
          label={`${trans('field.startup')} - ${trans('field.module')}`}
          list={[
            { id: 'client-list', type: trans('field.clients') },
            { id: 'sls-doc-list', type: trans('field.sales') },
            { id: 'calendar-view', type: trans('field.calendar') },
          ]}
        />
        <CxCombo xref={rf_inet_outage_notice}
          label={`${trans('field.internet_outage_notice')}`}
          list={[
            { id: 'Y', type: trans('field.yes') },
            { id: 'N', type: trans('field.no') },
          ]}
        />

        <CxAccordion title={trans('field.printing')} background={"var(--ibs_color_gray_light)"} color={"var(--ibs_color_black)"} defaultExpanded >
          <CxCombo xref={rf_sales_slip_width}
            label={`${trans('field.sales_slip')} - ${trans('field.width')}`}
            list={[
              { id: '45', type: '45mm' },
              { id: '60', type: '60mm' },
              { id: '70', type: '70mm' },
              { id: '80', type: '80mm' },
            ]}
          />
          <CxNumber xref={rf_sales_slip_margin_left} decimals={0}
            label={`${trans('field.sales_slip')} - ${trans('field.margin_left')}`} />
        </CxAccordion>

      </GxForm>

      <CxSnackbar xref={r_snack_save} severity="success" value={trans('msg.saved')} />
    </div>
  );

}

export default MxPrefsLocalsForm;
